import { render, staticRenderFns } from "./RegistryEvidence.vue?vue&type=template&id=f49e8aaa"
import script from "./RegistryEvidence.vue?vue&type=script&lang=js"
export * from "./RegistryEvidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49e8aaa')) {
      api.createRecord('f49e8aaa', component.options)
    } else {
      api.reload('f49e8aaa', component.options)
    }
    module.hot.accept("./RegistryEvidence.vue?vue&type=template&id=f49e8aaa", function () {
      api.rerender('f49e8aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryEvidence.vue"
export default component.exports